<div class="swag-migration-wizard swag-migration-wizard-page-credentials">
    {% block swag_migration_wizard_page_credentials_content %}
            {% block swag_migration_wizard_page_credentials_information %}
                <div class="swag-migration-wizard__content-information">
                    <h3 class="swag-migration-wizard__information-header">
                        {{ $tc('swag-migration.wizard.pages.credentials.shopware55.api.title') }}
                    </h3>
                    <ol class="swag-migration-wizard-page-credentials__steps">
                        <li>
                            <i18n-t
                                keypath="swag-migration.wizard.pages.credentials.shopware55.api.steps.step1"
                                tag="span"
                                scope="local"
                            >
                                <template #pluginName>
                                    {{ $tc('swag-migration.wizard.pages.credentials.shopware55.api.pluginName') }}
                                </template>
                            </i18n-t>

                            <mt-link
                                as="a"
                                :to="storeLink"
                                target="_blank"
                                type="external"
                            >
                                {{ $tc('swag-migration.wizard.pages.credentials.shopware55.api.pluginLinkText') }}
                            </mt-link>
                        </li>

                        <li>{{ $tc('swag-migration.wizard.pages.credentials.shopware55.api.steps.step2') }}</li>
                        <li>{{ $tc('swag-migration.wizard.pages.credentials.shopware55.api.steps.step3') }}</li>
                        <li>{{ $tc('swag-migration.wizard.pages.credentials.shopware55.api.steps.step4') }}</li>
                        <li>{{ $tc('swag-migration.wizard.pages.credentials.shopware55.api.steps.step5') }}</li>
                        <li>{{ $tc('swag-migration.wizard.pages.credentials.shopware55.api.steps.step6') }}</li>
                    </ol>
                </div>
            {% endblock %}

            {% block swag_migration_wizard_page_credentials_credentials %}
            <div class="swag-migration-wizard__form">
                {% block swag_migration_wizard_page_credentials_apikey_field %}
                    <mt-text-field
                        v-model:model-value="inputCredentials.apiKey"
                        v-autofocus
                        name="sw-field--apiKey"
                        :label="$tc('swag-migration.wizard.pages.credentials.shopware55.api.apiKeyLabel')"
                        :placeholder="$tc('swag-migration.wizard.pages.credentials.shopware55.api.apiKeyPlaceholder')"
                        :help-text="$tc('swag-migration.wizard.pages.credentials.shopware55.api.apiKeyTooltip')"
                        :error="apiKeyError"
                    >
                        {% block swag_migration_wizard_page_credentials_apikey_icon %}
                            <template #suffix>
                                <mt-icon name="regular-key" />
                            </template>
                        {% endblock %}
                    </mt-text-field>
                {% endblock %}

                {% block swag_migration_wizard_page_credentials_apiuser_field %}
                    <mt-text-field
                        v-model:model-value="inputCredentials.apiUser"
                        name="sw-field--apiUser"
                        :label="$tc('swag-migration.wizard.pages.credentials.shopware55.api.apiUserLabel')"
                        :placeholder="$tc('swag-migration.wizard.pages.credentials.shopware55.api.apiUserPlaceholder')"
                        :help-text="$tc('swag-migration.wizard.pages.credentials.shopware55.api.apiUserTooltip')"
                        validation="required"
                    >
                        {% block swag_migration_wizard_page_credentials_apiuser_icon %}
                            <template #suffix>
                                <mt-icon name="regular-user" />
                            </template>
                        {% endblock %}
                    </mt-text-field>
                {% endblock %}

                {% block swag_migration_wizard_page_credentials_endpoint_field %}
                    <mt-url-field
                        v-model:model-value="inputCredentials.endpoint"
                        :validation="inputCredentials.endpoint !== 'http://' && inputCredentials.endpoint !== 'https://'"
                        :label="$tc('swag-migration.wizard.pages.credentials.shopware55.api.endpointLabel')"
                        :placeholder="$tc('swag-migration.wizard.pages.credentials.shopware55.api.endpointPlaceholder')"
                        :switch-label="$tc('swag-migration.wizard.pages.credentials.shopware55.api.endpointSSLLabel')"
                        required
                    />
                {% endblock %}
            </div>
            {% endblock %}
    {% endblock %}
</div>
